import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AIApp from './ai/AIApp';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './services/AuthContext';

// Single build, subdomain-branched at boot. ai.qada.io mounts the AI-native
// shell; anything else keeps the existing broker app untouched. Kept as a
// hostname check (not a build-time env var) so a single deployed bundle in
// /var/www/frontend can serve BOTH app.qada.io and ai.qada.io — no separate
// build pipeline, no risk of drift.
const isAI =
  typeof window !== 'undefined' &&
  window.location.hostname.startsWith('ai.');

const RootApp = isAI ? AIApp : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RootApp />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
